import ApiHttp from '../http';

class ContactUsService {
    /**
     * Service for submitting contact us form requests
     */
    constructor() {
    }

    sendContactUs(formData) {
        // console.log("service formData", formData)
        if(formData) {
            return ApiHttp.post("/contact-us/send", {formData: formData}).then((result) => (console.log(result)),
            (error) => {
                return Promise.reject(error);
            });
        }
    }

    sendWelcomeMailFan(formData) {
        // console.log("service formData", formData)
        if(formData) {
            return ApiHttp.post("/welcome/fan", {formData: formData}).then((result) => (console.log(result)),
            (error) => {
                return Promise.reject(error);
            });
        }
    }

    sendWelcomeMailMORvies(formData) {
        // console.log("service formData", formData)
        if(formData) {
            return ApiHttp.post("/welcome/morvies", {formData: formData}).then((result) => (console.log(result)),
            (error) => {
                return Promise.reject(error);
            });
        }
    }
}

export default new ContactUsService();


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/service/contact-us-service.js